<template>
  <div class="platform-operations">
    <el-tabs v-model="activeTab" class="platform-tabs">
      <el-tab-pane label="基础操作" name="owner">
        <!-- 注销手机号 -->
        <div class="operation-card zhuxiao_box">
          <div class="zhuxiao_item">
            <div class="card-header">
              <h3 class="card-title">注销注册成实际承运人的托运人手机号</h3>
              <h4 class="card-subtitle" style="color: red;">
                此处禁止操作实际承运人手机号,实际承运人信息请前往【运力中心】操作
              </h4>
              <p class="card-subtitle">
                请确认要注销的手机号下无未结算的运单和提现金额
              </p>
            </div>
            <div class="card-content">
              <div class="form-row">
                <label class="form-label">手机号</label>
                <el-input
                  v-model="phoneForm.phoneNumber"
                  placeholder="请输入要注销的手机号"
                  max-length="11"
                  class="form-input"
                />
                <el-button
                  :loading="phoneLoading"
                  type="primary"
                  class="query-btn"
                  @click="queryPhone"
                  >查询</el-button
                >
              </div>

              <div v-if="phoneInfo.phone" class="phone-info">
                <div class="info-row">
                  <span class="info-value">{{ phoneInfo.name || "--" }}</span>
                  <span class="info-value ml-30">{{ phoneInfo.phone }}</span>
                  <el-button
                    type="danger"
                    class="cancel-btn"
                    @click="cancelPhone(phoneInfo.phone)"
                    >注销</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="zhuxiao_item">
            <div class="card-header">
              <h3 class="card-title">注销注册成个人托运人的托运人手机号</h3>
              <!-- <h4 class="card-subtitle" style="color: red;">
                此处禁止操作实际承运人手机号,实际承运人信息请前往【运力中心】操作
              </h4> -->
              <p class="card-subtitle">
                请确认要注销的手机号下无未结算的运单和提现金额
              </p>
            </div>
            <div class="card-content">
              <div class="form-row">
                <label class="form-label">手机号</label>
                <el-input
                  v-model="phone2"
                  placeholder="请输入要注销的手机号"
                  max-length="11"
                  class="form-input"
                />
                <el-button
                  :loading="phone2Loading"
                  type="primary"
                  class="query-btn"
                  @click="shipmentInfoApi"
                  >查询</el-button
                >
              </div>

              <div v-if="phone2Info.phone" class="phone-info">
                <div class="info-row">
                  <span class="info-value">{{
                    phone2Info.userName || "--"
                  }}</span>
                  <span class="info-value ml-30">{{ phone2Info.phone }}</span>
                  <el-button
                    type="danger"
                    class="cancel-btn"
                    @click="deleteShipmentApi(phone2Info.phone)"
                    >注销</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 更改装卸车吨位 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">更改装卸车吨位</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <label class="form-label">运单号</label>
              <el-input
                v-model="waybillNo"
                placeholder="请输入要修改的运单单号"
                class="form-input"
              />
              <el-button type="primary" class="query-btn" @click="queryWaybill"
                >查询</el-button
              >
            </div>

            <div v-if="waybillInfo.orderCode" class="waybill-info">
              <div class="info-row">
                <span class="info-label">运单号：</span>
                <span class="info-value">{{ waybillInfo.orderCode }}</span>
                <span class="info-label ml-30">运单状态：</span>
                <span class="info-value">{{
                  getStatusLabel(waybillInfo.statusNew)
                }}</span>
              </div>

              <div v-if="waybillInfo.statusNew !== 1" class="form-row mt-20">
                <div class="form-group">
                  <label class="form-label">装车数量</label>
                  <el-input
                    v-model="waybillInfo.loadQuantity"
                    class="quantity-input"
                  />
                  <span class="unit">吨</span>
                </div>
                <div v-if="waybillInfo.statusNew !== 2" class="form-group">
                  <label class="form-label">卸车吨位</label>
                  <el-input
                    v-model="waybillInfo.unloadWeight"
                    class="quantity-input"
                  />
                  <span class="unit">吨</span>
                </div>
                <div v-if="waybillInfo.statusNew !== 2" class="form-group">
                  <label class="form-label">结算数量</label>
                  <!-- waybillInfo.settlementWeight -->
                  <el-input
                    v-model="minWeight"
                    class="quantity-input"
                    :disabled="true"
                  />
                  <span class="unit">吨</span>
                </div>
                <el-button
                  type="primary"
                  class="modify-btn"
                  @click="updateQuantity"
                  >修改</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 更改开户行 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">更改开户行</h3>
            <p class="card-subtitle">请确认托运人信息已提交审核</p>
          </div>
          <div class="card-content">
            <div class="form-row">
              <label class="form-label">托运人账号</label>
              <el-input
                v-model="bankForm.phone"
                placeholder="请输入托运人注册手机号"
                class="form-input"
                max-length="11"
              />
              <el-button type="primary" class="query-btn" @click="queryBankInfo"
                >查询</el-button
              >
            </div>

            <div v-if="bankInfo.companyName" class="bank-info">
              <div class="info-row">
                <label class="form-label">公司名称：</label>
                <span class="info-value">{{ bankInfo.companyName }}</span>
              </div>

              <div class="form-row mt-20">
                <div class="form-group full-width">
                  <label class="form-label">银行名称：</label>
                  <el-input v-model="bankInfo.bankName" class="bank-input" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group full-width">
                  <label class="form-label">开户行名称：</label>
                  <el-input v-model="bankInfo.branche" class="bank-input" />
                </div>
              </div>

              <div class="form-row center">
                <el-button
                  type="primary"
                  class="modify-btn"
                  @click="updateBankInfo"
                  >修改</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 修改装卸货照片 -->
        <el-form>
          <div class="operation-card">
            <div class="card-header">
              <h3 class="card-title">修改装卸货照片</h3>
            </div>
            <div class="card-content">
              <div class="form-row">
                <div class="form-group">
                  <div>
                    <label class="form-label">运单号</label>
                    <el-input
                      v-model="imgForm.orderCode"
                      placeholder="请输入要修改的运单单号"
                      class="form-input"
                    />
                  </div>
                  <div>
                    <label class="form-label">图片类型</label>
                    <el-select v-model="imgForm.type" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </div>
                <el-button
                  type="primary"
                  class="query-btn"
                  @click="getImgInfoApi"
                  >查询</el-button
                >
              </div>
              <div
                v-if="Array.isArray(ImgDetail) && ImgDetail.length"
                class="img-section"
              >
                <div class="img-grid">
                  <div
                    v-for="(item, index) in ImgDetail"
                    v-if="item.url"
                    :key="index"
                    class="img-item"
                  >
                    <template>
                      <div class="old-img">
                        <img :src="normalizeUrl(item)" class="preview" />
                      </div>
                      <div class="upload-area">
                        <img
                          v-if="item.urlNew"
                          style="width:150px;height:150px;"
                          :src="normalizeUrl(item.urlNew)"
                          alt=""
                        />
                        <ImgUpload
                          v-if="!item.urlNew"
                          :upload-config="{
                            lebal: '请上传新图片',
                            prefix: 'str',
                            form: {},
                            suffix: 'Img',
                            modal: false
                          }"
                          @handleImgSuccess="
                            vehicleLicenseBackSuccess(index, $event)
                          "
                        />
                      </div>
                      <el-button
                        type="primary"
                        class="modify-btn"
                        :disabled="!item.urlNew"
                        @click="updateImgInfoApi(item)"
                        >提交修改</el-button
                      >
                    </template>
                  </div>
                </div>
                <!-- <div class="form-row center">
              <el-button
                type="primary"
                class="modify-btn"
                :disabled="!imgReplacements.length"
                @click="updateImgInfoApi"
                >提交修改</el-button
              >
            </div> -->
              </div>
              <div v-else class="tips">
                <p>查询后显示相关图片，可逐个上传新图进行替换。</p>
              </div>
            </div>
          </div>
        </el-form>
        <!-- 修改公司名称 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">修改公司名称</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">公司名称</label>
                <el-select
                  v-model="selectShipmentCode"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in shipmentList"
                    :key="item.code"
                    :label="shipmentDisplayName(item)"
                    :value="item.code"
                  />
                </el-select>
                <label class="form-label" style="margin-left: 20px;"
                  >修改后公司名称</label
                >
                <el-input
                  v-model="reCompanyName"
                  placeholder="请输入修改后公司名称"
                  class="form-input"
                />
                <el-button
                  type="primary"
                  class="modify-btn"
                  :loading="isRenameCompanyLoading"
                  @click="renameCompanyApi"
                  >提交修改</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 修改运单装卸货行政区划编码 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">修改运单行政区划编码</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <label class="form-label">运单号</label>
              <el-input
                v-model="subdivisionOrderCode"
                placeholder="请输入运单单号"
                class="form-input"
                clearable
              />
              <el-button
                type="primary"
                class="query-btn"
                :loading="subdivisionQueryLoading"
                @click="queryOrderAddress"
                >查询</el-button
              >
            </div>

            <div
              v-if="subdivisionInfo.orderCode"
              class="waybill-info subdivision-info"
            >
              <div class="info-row">
                <label class="form-label">装货地址：</label>
                <span class="info-value">{{
                  subdivisionShipperAddress || "--"
                }}</span>
              </div>
              <div class="form-row mt-20">
                <div class="form-group full-width">
                  <label class="form-label">装货行政区划编码</label>
                  <el-input
                    v-model="subdivisionInfo.shipperSubdivisionCode"
                    placeholder="请输入装货地点国家行政区划代码"
                    class="bank-input"
                    clearable
                  />
                </div>
              </div>
              <div class="info-row">
                <label class="form-label">卸货地址：</label>
                <span class="info-value">{{
                  subdivisionConsigneeAddress || "--"
                }}</span>
              </div>
              <div class="form-row">
                <div class="form-group full-width">
                  <label class="form-label">卸货行政区划编码</label>
                  <el-input
                    v-model="subdivisionInfo.consigneeSubdivisionCode"
                    placeholder="请输入收货国家行政区划代码"
                    class="bank-input"
                    clearable
                  />
                </div>
              </div>
              <div class="form-row center">
                <el-button
                  type="primary"
                  class="modify-btn"
                  :loading="subdivisionUpdateLoading"
                  @click="updateSubdivisionCode"
                  >提交修改</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="资金操作" name="fund">
        <!-- 结算异常：机构、金额 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">结算异常</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">机构</label>
                <el-select
                  v-model="abnormalObj.branchCode"
                  placeholder="请选择机构"
                  clearable
                  class="form-select"
                  @change="changeBranchCode"
                >
                  <el-option
                    v-for="item in branchList"
                    :key="item.code"
                    :label="item.groupName"
                    :value="item.code"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label class="form-label">金额</label>
                <el-input
                  v-model="abnormalObj.money"
                  placeholder="请输入金额"
                  class="form-input"
                  clearable
                  @input="handleMoneyInput"
                />
              </div>
              <el-button
                type="primary"
                class="modify-btn"
                :disabled="!isAbnormalFormValid"
                :loading="transferFeeLoading"
                @click="transferFeeAccountApi"
                >提交修改</el-button
              >
            </div>
            <div v-if="showCompanyName" class="form_row_bg">
              <div class="form-group">
                <label class="form-label">企业名称</label>
                <el-autocomplete
                  v-model="slectShipper"
                  class="form-input"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入企业名称"
                  clearable
                  @select="handleSelect"
                />
              </div>

              <div class="form-group">
                <label class="form-label">转账金额</label>
                <el-input
                  v-model="transferAmount"
                  clearable
                  placeholder="请输入转账金额"
                />
              </div>
              <div class="form-group">
                <label class="form-label">可转账金额</label>
                <span style="color: red;font-weight: bold;"
                  >￥{{ balance }}</span
                >
              </div>
              <el-button
                :loading="isLoaidngAmount"
                type="primary"
                class="modify-btn"
                @click="changeAmount"
                >确定</el-button
              >
            </div>
          </div>
        </div>
        <!-- 暂挂资金 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">暂挂资金</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">机构</label>
                <el-select
                  v-model="moneyBranchCode"
                  placeholder="请选择机构"
                  clearable
                  class="form-select"
                  @change="changeMoneyBranchCode"
                >
                  <el-option
                    v-for="item in branchList"
                    :key="item.code"
                    :label="item.groupName"
                    :value="item.code"
                  />
                </el-select>
              </div>
              <!-- :disabled="!isAbnormalFormValid" -->
              <el-button
                type="primary"
                class="modify-btn"
                :loading="isMoneyReturnLoading"
                @click="getPendingMoneyApi"
                >查询</el-button
              >
            </div>
            <div
              v-if="
                Array.isArray(moneyList) &&
                  moneyList.length === 0 &&
                  moneyBranchCode
              "
              class="tips"
            >
              <p>未查询到相关数据</p>
            </div>
            <div
              v-if="
                Array.isArray(moneyList) && moneyList.length && moneyBranchCode
              "
            >
              <el-table :data="moneyList" border style="width: 100%">
                <el-table-column
                  prop="fcsSerialNum"
                  label="资金流水号"
                  width="180"
                />
                <el-table-column
                  prop="bankAccount"
                  label="对方实体账号"
                  width="180"
                />
                <el-table-column prop="memName" label="账户名称" />
                <el-table-column prop="tradeAmount" label="发生金额" />
                <el-table-column prop="procTime" label="账务时间" />
                <el-table-column prop="busType" label="业务类型" />
                <el-table-column prop="brief" label="摘要" />
                <el-table-column fixed="right" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click.native.prevent="moneyReturnApi(scope.row)"
                    >
                      原路退回
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      @click.native.prevent="clearPendingFundsApi(scope.row)"
                    >
                      清 分
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 实际承运人银行卡冻结 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">实际承运人余额冻结</h3>
          </div>

          <div class="card-content">
            <div class="card-content">
              <div class="form-row">
                <label class="form-label">手机号</label>
                <el-input
                  v-model="phoneForm.phoneNumber"
                  placeholder="请输入实际承运人手机号"
                  max-length="11"
                  class="form-input"
                  clearable
                />
                <el-button
                  :loading="phoneLoading"
                  type="primary"
                  class="query-btn"
                  @click="queryPhone('bank')"
                  >查询</el-button
                >
              </div>

              <div v-if="phoneInfo.phone" class="phone-info">
                <div>
                  <span class="info-value">{{ phoneInfo.name || "--" }}</span>
                  <span class="info-value ml-30">{{ phoneInfo.phone }}</span>
                  <div
                    v-for="item in bankDriverInfo"
                    :key="item.id"
                    class="info-row"
                  >
                    <span class="info-value"
                      >主体:{{ getBranchName(item.branchCode) || "--" }}</span
                    >
                    <span class="info-value ml-30"
                      >金额:{{ item.balance || "--" }}</span
                    >
                    <el-input
                      v-model="item.freezeAmount"
                      style="width: 200px;"
                      class="ml-30 m_r_30"
                      placeholder="请输入冻结金额"
                    />
                    <el-button
                      type="danger"
                      class="cancel-btn"
                      @click="freezeFundsApi(item)"
                      >冻结</el-button
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="FundFreezeRecordList.length"
                style="width:800px;margin-top: 20px;"
              >
                <el-table :data="FundFreezeRecordList" border>
                  <el-table-column prop="branchName" label="主体" width="260">
                    <template slot-scope="scope">
                      {{ getBranchName(scope.row.branchCode) || "--" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="amount" label="冻结金额(元)" />
                  <el-table-column prop="gmtCreated" label="冻结时间" />
                  <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="unFreezeFundsApi(scope.row)"
                        >解冻</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="手机号登录白名单" name="phoneWhite">
        <!-- 手机号登录白名单 -->
        <div class="operation-card">
          <div class="card-header">
            <h3 class="card-title">手机号登录白名单</h3>
          </div>
          <div class="card-content">
            <div class="form-row">
              <el-button type="primary" class="modify-btn" @click="addPhoneApi"
                >添加</el-button
              >
            </div>
            <!-- 已授权的手机号白名单 -->
            <div v-if="phoneWhiteList.length" class=" phone-white-list">
              <h4 style="margin-bottom: 4px;">已授权的手机号白名单</h4>
              <el-table
                :data="phoneWhiteTableData"
                :show-header="false"
                border
                style="width: 100%"
              >
                <el-table-column
                  v-for="colIndex in 4"
                  :key="colIndex"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row[colIndex - 1]" class="phone-cell">
                      <span class="phone-text">{{
                        scope.row[colIndex - 1]
                      }}</span>
                      <i
                        class="el-icon-delete delete-icon"
                        @click="deletePhoneWhiteApi(scope.row[colIndex - 1])"
                      />
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="新增手机号白名单"
      :visible.sync="addPhoneDialogVisible"
      :close-on-click-modal="false"
      width="480px"
    >
      <el-input
        v-model="addPhoneForm.phone"
        type="textarea"
        :rows="6"
        placeholder="请输入手机号，多手机号用逗号分隔"
        clearable
      />
      <div slot="footer">
        <el-button
          type="primary"
          :loading="addPhoneWhiteLoading"
          @click="confirmAddPhoneApi"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDriverTeamList,
  deleteUser,
  getBankInfo,
  updateBankInfo,
  getInfoByCode,
  updateInfoByCode,
  getOrderAddress,
  updateOrderAddressSubdivisionCode,
  getImgInfo,
  updateImgInfo,
  transferFeeAccount,
  getPendingMoney,
  moneyReturn,
  clearPendingFunds,
  shipmentInfo,
  deleteShipment,
  updateCompanyInfo,
  getAccountList,
  freezeFunds,
  unFreezeFunds,
  getFundFreezeRecordList
} from "@/api/driver";
import {
  getShipperList,
  queryBalance,
  transferCustomerAccount
} from "@/api/shipment";
import {
  addPhoneWhiteList,
  getPhoneWhiteList,
  deletePhoneWhiteList
} from "@/api/commonApi";
import ImgUpload from "@/components/ImgUpload/index.vue";
export default {
  name: "PlatformOperations",
  components: {
    ImgUpload
  },
  data() {
    return {
      phoneWhiteList: [],
      addPhoneDialogVisible: false,
      addPhoneWhiteLoading: false,
      addPhoneForm: {
        phone: ""
      },
      selectShipmentCode: "",
      phone2Info: {
        phone: ""
      },
      phone2Loading: false,
      phone2: "",
      showCompanyName: false,
      selectbranchCode: "",
      transferAmount: null,
      balance: 0,
      slectShipper: "",
      shipperList: [],
      isClearPendingFundsLoading: false,
      activeTab: "owner",
      abnormalObj: {
        branchCode: "",
        money: ""
      },
      branchList: this.$store.state.components.branchList,
      // 1待运输/2运输中/3待回单/4已到达/5托运人确认卸货（待结算）/6已结算/7已打款/
      statusOptions: [
        { value: 1, label: "待运输" },
        { value: 2, label: "运输中" },
        { value: 3, label: "待回单" },
        { value: 4, label: "已到达" },
        { value: 5, label: "待结算" },
        { value: 6, label: "已结算" },
        { value: 7, label: "已打款" }
      ],
      phoneLoading: false,
      transferFeeLoading: false,
      // 装卸车吨位相关数据
      waybillNo: "",
      waybillInfo: {
        orderCode: "", //运单号
        loadQuantity: "", //装车数量
        unloadWeight: "", //卸车吨位
        settlementWeight: "" //结算数量
      },

      // 注销手机号相关数据
      phoneForm: {
        phoneNumber: ""
      },
      phoneInfo: {
        name: "",
        phone: ""
      },

      // 更改开户行相关数据
      bankForm: {
        phone: ""
      },
      bankInfo: {
        companyName: "",
        bankName: "",
        branche: ""
      },
      options: [
        { value: "20001", label: "装车照片" },
        { value: "20012", label: "装车过磅单照片" },
        { value: "20002", label: "卸车照片" },
        { value: "20022", label: "卸车过磅照片" }
      ],
      imgForm: {
        orderCode: "",
        type: ""
      },
      ImgDetail: null,
      imgReplaceForm: {},
      imgReplacements: [],
      moneyList: null,
      moneyBranchCode: "",
      isMoneyReturnLoading: false,
      slectShipperPartyCode: "",
      isLoaidngAmount: false,
      shipmentList: [],
      renameCompanyForm: {
        code: ""
      },
      reCompanyName: "",
      isRenameCompanyLoading: false,
      FundFreezeRecordList: [],
      bankDriverInfo: [],
      // 修改运单行政区划编码
      subdivisionOrderCode: "",
      subdivisionQueryLoading: false,
      subdivisionUpdateLoading: false,
      subdivisionInfo: {
        orderCode: "",
        shipperAddress: "",
        shipperDetailAddress: "",
        shipperTotalAddress: "",
        consigneeAddress: "",
        consigneeDetailAddress: "",
        consigneeTotalAddress: "",
        shipperSubdivisionCode: "",
        consigneeSubdivisionCode: ""
      }
    };
  },
  computed: {
    subdivisionShipperAddress() {
      const info = this.subdivisionInfo;
      return (
        info.shipperTotalAddress ||
        [info.shipperAddress, info.shipperDetailAddress]
          .filter(Boolean)
          .join("") ||
        ""
      );
    },
    subdivisionConsigneeAddress() {
      const info = this.subdivisionInfo;
      return (
        info.consigneeTotalAddress ||
        [info.consigneeAddress, info.consigneeDetailAddress]
          .filter(Boolean)
          .join("") ||
        ""
      );
    },
    minWeight() {
      // 从两个值中取最小的一个
      return Math.min(
        this.waybillInfo.loadQuantity,
        this.waybillInfo.unloadWeight
      );
    },
    phoneWhiteTableData() {
      const chunkSize = 4;
      const rows = [];
      for (let i = 0; i < this.phoneWhiteList.length; i += chunkSize) {
        rows.push(this.phoneWhiteList.slice(i, i + chunkSize));
      }
      return rows;
    },
    // 检查结算异常表单是否可提交
    isAbnormalFormValid() {
      const branchCode = this.abnormalObj.branchCode;
      const money = this.abnormalObj.money;
      return (
        branchCode &&
        money !== null &&
        money !== undefined &&
        String(money).trim() !== ""
      );
    }
  },
  created() {
    this.getShipperListApi();
    this.getShipmentListApi();
    this.getPhoneWhiteListApi();
  },
  methods: {
    getBranchName(branchCode) {
      let branch = this.branchList.find(item => item.code === branchCode);
      return branch ? branch.groupName : "--";
    },
    async getPhoneWhiteListApi() {
      const res = await getPhoneWhiteList();
      if (res.status === 0) {
        let phones = res.data;
        if (typeof phones === "string") {
          phones = phones
            .split(",")
            .map(p => p.trim())
            .filter(Boolean);
        } else if (phones && phones.phone) {
          phones = phones.phone
            .split(",")
            .map(p => p.trim())
            .filter(Boolean);
        } else if (!Array.isArray(phones)) {
          phones = [];
        }
        this.phoneWhiteList = phones;
      }
    },
    addPhoneApi() {
      this.addPhoneForm.phone = "";
      this.addPhoneDialogVisible = true;
    },
    async confirmAddPhoneApi() {
      const text = this.addPhoneForm.phone.trim();
      if (!text) {
        this.$message.warning("请输入手机号");
        return;
      }
      const phones = text
        .split(/[\n,，\s]+/)
        .map(p => p.trim())
        .filter(Boolean);
      const invalidPhone = phones.find(p => !/^1[3-9]\d{9}$/.test(p));
      if (invalidPhone) {
        this.$message.warning(`手机号 ${invalidPhone} 格式不正确`);
        return;
      }
      this.addPhoneWhiteLoading = true;
      try {
        const res = await addPhoneWhiteList({
          phones: phones.join(",")
        });
        if (res.status === 0) {
          this.$message.success("添加成功");
          this.addPhoneDialogVisible = false;
          this.addPhoneForm.phone = "";
          this.getPhoneWhiteListApi();
        } else {
          this.$message.error(res.msg);
        }
      } finally {
        this.addPhoneWhiteLoading = false;
      }
    },
    deletePhoneWhiteApi(phone) {
      this.$confirm(`确认要删除手机号 ${phone} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await deletePhoneWhiteList({ phone });
          if (res.status === 0) {
            this.$message.success("删除成功");
            this.getPhoneWhiteListApi();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    async unFreezeFundsApi(item) {
      let res = await unFreezeFunds({
        id: item.id
      });
      if (res.status === 0) {
        this.$message.success("解冻成功");
        this.getFundFreezeRecordListApi(item);
        this.bankDriverInfo.forEach(item => {
          item.freezeAmount = null;
        });
        this.checkBankCard(this.phoneInfo);
      } else {
        this.$message.error(res.msg);
      }
    },
    async checkBankCard(phoneInfo) {
      if (!phoneInfo) return;
      let res = await getAccountList({
        partyCode: phoneInfo.partyCode
      });
      if (res.status === 0) {
        this.bankDriverInfo = res.data;
      }
    },
    // 获取实际承运人银行卡信息
    async getAccountListApi() {
      let res = await getAccountList({
        page: 1,
        pageSize: 2000
      });
      if (res.status === 0) {
        this.AccountList = res.data.records;
      }
    },
    // 资金冻结
    async freezeFundsApi(item) {
      console.log("item", item);
      if (!item.freezeAmount) {
        this.$message.warning("请输入冻结金额");
        return;
      }
      let res = await freezeFunds({
        branchCode: item.branchCode,
        partyCode: item.partyCode,
        fromAccountName: item.memNum,
        amount: item.freezeAmount
      });
      if (res.status === 0) {
        this.$message.success("冻结成功");
        this.getFundFreezeRecordListApi(item);
        this.bankDriverInfo.forEach(item => {
          item.freezeAmount = null;
        });
        this.checkBankCard(this.phoneInfo);
      } else {
        this.$message.error(res.msg);
      }
    },

    // 索取冻结列表
    async getFundFreezeRecordListApi(item) {
      let res = await getFundFreezeRecordList({
        page: 1,
        pageSize: 2000,
        partyCode: this.phoneInfo.partyCode,
        status: 0
      });
      if (res.status === 0) {
        this.FundFreezeRecordList = res.data.records;
      }
    },
    async renameCompanyApi() {
      if (!this.selectShipmentCode) {
        this.$message.warning("请选择公司");
        return;
      }
      if (!this.reCompanyName) {
        this.$message.warning("请输入修改后公司名称");
        return;
      }
      this.isRenameCompanyLoading = true;
      let res = await updateCompanyInfo({
        code: this.selectShipmentCode,
        companyName: this.reCompanyName
      });
      if (res.status === 0) {
        this.$message.success("修改成功");
      }
      this.isRenameCompanyLoading = false;
    },
    async getShipmentListApi() {
      let res = await shipmentInfo({
        staffType: 1,
        subType: 2,
        pageNum: 1,
        pageSize: 2000
      });
      if (res.status === 0) {
        const d = res.data;
        this.shipmentList = Array.isArray(d) ? d : (d && d.records) || [];
      }
    },
    shipmentDisplayName(item) {
      if (!item) return "";
      return item.companyName || "--";
    },
    async shipmentInfoApi() {
      if (!this.phone2) {
        this.$message.warning("请输入手机号");
        return;
      }
      // 正则校验手机号
      if (!/^1[3-9]\d{9}$/.test(this.phone2)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      this.phone2Loading = true;
      let res = await shipmentInfo({
        phone: this.phone2,
        staffType: 1
      });
      if (res.status === 0) {
        if (res.data.records.length > 0) {
          this.phone2Info = res.data.records[0];
        } else {
          this.$message.warning("未查询到相关数据");
        }
      }
      this.phone2Loading = false;
    },
    async deleteShipmentApi(phone) {
      if (!phone) {
        this.$message.warning("请先查询手机号");
        return;
      }
      this.$confirm(`确认要注销${phone}手机号吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.isDeleteShipmentLoading = true;
          let res = await deleteShipment({
            phone: phone
          });
          if (res.status === 0) {
            this.$message.success("删除成功");
            this.phone2 = "";
            this.phone2Info = {};
          }
        })
        .catch(() => {
          this.isDeleteShipmentLoading = false;
        });
    },
    changeAmount() {
      console.log("changeAmount", this.transferAmount);
      if (this.transferAmount > +this.balance) {
        this.$message.warning("转账金额不能大于可转账金额");
        return;
      }
      this.transferCustomerAccountApi();
    },
    async transferCustomerAccountApi() {
      this.isLoaidngAmount = true;
      try {
        let res = await transferCustomerAccount({
          branchCode: this.selectbranchCode,
          partyCode: this.slectShipperPartyCode,
          money: this.transferAmount
        });
        this.isLoaidngAmount = false;
        if (res.status === 0) {
          this.$message.success("转账成功");
          this.showCompanyName = false;
          this.transferAmount = null;
          this.slectShipperPartyCode = "";
          this.selectbranchCode = "";
          this.abnormalObj.branchCode = null;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.isLoaidngAmount = false;
      }
    },
    changeBranchCode(item) {
      console.log("item", item);
      if (!item) return;
      this.selectbranchCode = item;
      this.queryBalanceApi(item);
    },
    async queryBalanceApi(item) {
      let res = await queryBalance({
        branchCode: item
      });
      if (res.status === 0) {
        this.balance = res.data;
        this.showCompanyName = true;
      }
    },
    handleSelect(item) {
      console.log("item==============", item.partyCode);
      this.slectShipperPartyCode = item.partyCode;
    },
    querySearch(queryString, cb) {
      var restaurants = this.shipperList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return item => {
        const name = (item.companyName || item.value || "").toLowerCase();
        return name.indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    async getShipperListApi() {
      let res = await getShipperList({
        page: 1,
        pageSize: 2000,
        staffType: 1
      });
      if (res.status === 0) {
        this.shipperList = (res.data.records || []).map(item => ({
          ...item,
          value: item.companyName || ""
        }));
      }
    },
    clearPendingFundsApi(row) {
      this.$confirm("确认要清分吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.isClearPendingFundsLoading = true;
          let res = await clearPendingFunds({
            busiNum: row.busiNum,
            bankAccount: row.bankAccount,
            fcsSerialNum: row.fcsSerialNum
          });
          if (res.status === 0) {
            this.$message.success("清分成功");
            this.getPendingMoneyApi();
            this.isClearPendingFundsLoading = false;
          } else {
            this.isClearPendingFundsLoading = false;
          }
        })
        .catch(() => {
          this.isClearPendingFundsLoading = false;
          // this.$message.info("已取消清分");
        })
        .finally(() => {
          this.isClearPendingFundsLoading = false;
        });
    },
    changeMoneyBranchCode() {
      this.moneyList = null;
    },
    async moneyReturnApi(row) {
      this.$confirm("确认要退回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.isMoneyReturnLoading = true;
          let res = await moneyReturn({
            busiNum: row.busiNum,
            fcsSerialNum: row.fcsSerialNum
          });
          if (res.status === 0) {
            this.$message.success("退回成功");
            this.getPendingMoneyApi();
            this.isMoneyReturnLoading = false;
          } else {
            this.isMoneyReturnLoading = false;
          }
        })
        .catch(() => {
          this.isMoneyReturnLoading = false;
          // this.$message.info("已取消退回");
        })
        .finally(() => {
          this.isMoneyReturnLoading = false;
        });
    },
    // 处理金额输入，只允许数字和最多两位小数
    handleMoneyInput(value) {
      if (!value && value !== 0) {
        this.abnormalObj.money = "";
        return;
      }

      // 移除非数字和小数点的字符
      let formattedValue = value.toString().replace(/[^\d.]/g, "");

      // 确保只有一个小数点（取第一个小数点，后面的忽略）
      const firstDotIndex = formattedValue.indexOf(".");
      if (firstDotIndex !== -1) {
        const beforeDot = formattedValue.substring(0, firstDotIndex + 1);
        const afterDot = formattedValue
          .substring(firstDotIndex + 1)
          .replace(/\./g, "");
        formattedValue = beforeDot + afterDot;
      }

      // 限制小数位数为2位
      const parts = formattedValue.split(".");
      if (parts.length === 2 && parts[1].length > 2) {
        formattedValue = parts[0] + "." + parts[1].substring(0, 2);
      }

      // 更新值
      this.abnormalObj.money = formattedValue;
    },
    async getPendingMoneyApi() {
      if (!this.moneyBranchCode) {
        this.$message.warning("请选择机构");
        return;
      }
      let res = await getPendingMoney({
        branchCode: this.moneyBranchCode
      });
      if (res.status === 0) {
        this.moneyList = res.data.records;
      }
    },
    async transferFeeAccountApi() {
      this.transferFeeLoading = true;
      try {
        let res = await transferFeeAccount({
          branchCode: this.abnormalObj.branchCode,
          money: +this.abnormalObj.money
        });
        this.abnormalObj.money = null;
        if (res.status === 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } finally {
        this.transferFeeLoading = false;
        this.abnormalObj.money = null;
      }
    },
    vehicleLicenseBackSuccess(i, res) {
      console.log("返回的图片=====", res, i);
      this.ImgDetail[i].urlNew = res;
      this.$forceUpdate();
    },
    updateImgInfoApi(item) {
      console.log("updateImgInfoApi", item);
      updateImgInfo({
        code: item.linkCode,
        type: item.type,
        oldImagesUrl: item.url,
        newImagesUrl: item.urlNew
      }).then(res => {
        if (res.status === 0) {
          this.$message.success("图片更新成功");
          this.getImgInfoApi();
        }
      });
    },
    getImgInfoApi() {
      getImgInfo({
        orderCode: this.imgForm.orderCode,
        type: this.imgForm.type
      }).then(res => {
        console.log("获取图片信息", res);
        if (res.status === 0) {
          this.ImgDetail = res.data || [];
          this.ImgDetail.forEach(item => {
            item.urlNew = "";
          });
        }
      });
    },
    normalizeUrl(item) {
      if (!item) return "";
      const url = typeof item === "string" ? item : item.url || "";
      return url.replace(/^http:/, "https:");
    },
    handleReplaceImage(index, newUrl) {
      const oldUrl = this.normalizeUrl(this.ImgDetail[index]);
      const exists = this.imgReplacements.find(i => i.index === index);
      if (exists) {
        exists.newUrl = newUrl;
      } else {
        this.imgReplacements.push({ index, oldUrl, newUrl });
      }
    },
    getStatusLabel(status) {
      const statusObj = this.statusOptions.find(item => item.value === status);
      return statusObj ? statusObj.label : "";
    },
    // 获取实际承运人团队列表  13500000040
    async queryPhone(type = "") {
      if (!this.phoneForm.phoneNumber) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (this.phoneForm.phoneNumber.length !== 11) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      this.phoneLoading = true;
      const res = await getDriverTeamList({
        phone: this.phoneForm.phoneNumber
      });
      this.phoneLoading = false;
      if (res.status === 0) {
        if (res.data.records.length === 0) {
          this.$message.warning("手机号不存在");
          return;
        }
        this.phoneInfo = res.data.records[0];
        if (type === "bank") {
          this.checkBankCard(this.phoneInfo);
          this.getFundFreezeRecordListApi();
        }
      }
      console.log("111111", res);
    },
    // 查询运单信息
    queryWaybill() {
      if (!this.waybillNo) {
        this.$message.warning("请输入运单号");
        return;
      }
      getInfoByCode({
        orderCode: this.waybillNo
      }).then(res => {
        if (res.status === 0 && res.data) {
          this.waybillInfo = res.data;
        }
        if (res.status === 0 && !res.data) {
          this.$message.warning("请输入正确的运单号");
          return;
        }
      });
    },

    // 查询运单装卸货地址及行政区划编码
    async queryOrderAddress() {
      if (!this.subdivisionOrderCode) {
        this.$message.warning("请输入运单号");
        return;
      }
      this.subdivisionQueryLoading = true;
      try {
        const res = await getOrderAddress({
          orderCode: this.subdivisionOrderCode
        });
        if (res.status === 0 && res.data) {
          this.subdivisionInfo = {
            orderCode: res.data.orderCode || this.subdivisionOrderCode,
            shipperAddress: res.data.shipperAddress || "",
            shipperDetailAddress: res.data.shipperDetailAddress || "",
            shipperTotalAddress: res.data.shipperTotalAddress || "",
            consigneeAddress: res.data.consigneeAddress || "",
            consigneeDetailAddress: res.data.consigneeDetailAddress || "",
            consigneeTotalAddress: res.data.consigneeTotalAddress || "",
            shipperSubdivisionCode: res.data.shipperSubdivisionCode || "",
            consigneeSubdivisionCode: res.data.consigneeSubdivisionCode || ""
          };
        } else if (res.status === 0 && !res.data) {
          this.subdivisionInfo = {
            orderCode: "",
            shipperAddress: "",
            shipperDetailAddress: "",
            shipperTotalAddress: "",
            consigneeAddress: "",
            consigneeDetailAddress: "",
            consigneeTotalAddress: "",
            shipperSubdivisionCode: "",
            consigneeSubdivisionCode: ""
          };
          this.$message.warning("请输入正确的运单号");
        }
      } finally {
        this.subdivisionQueryLoading = false;
      }
    },

    // 修改运单装卸货行政区划编码
    updateSubdivisionCode() {
      if (!this.subdivisionInfo.orderCode) {
        this.$message.warning("请先查询运单");
        return;
      }
      if (!this.subdivisionInfo.shipperSubdivisionCode) {
        this.$message.warning("请输入装货行政区划编码");
        return;
      }
      if (!this.subdivisionInfo.consigneeSubdivisionCode) {
        this.$message.warning("请输入卸货行政区划编码");
        return;
      }
      this.$confirm("确认要修改运单行政区划编码吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.subdivisionUpdateLoading = true;
          try {
            const res = await updateOrderAddressSubdivisionCode({
              orderCode: this.subdivisionInfo.orderCode,
              shipperSubdivisionCode: this.subdivisionInfo
                .shipperSubdivisionCode,
              consigneeSubdivisionCode: this.subdivisionInfo
                .consigneeSubdivisionCode
            });
            if (res.status === 0) {
              this.$message.success("修改成功");
            }
          } finally {
            this.subdivisionUpdateLoading = false;
          }
        })
        .catch(() => {
          this.$message.info("已取消修改");
        });
    },

    // 修改数量
    updateQuantity() {
      if (!this.waybillInfo.orderCode) {
        this.$message.warning("请输入运单号");
        return;
      }
      this.$confirm("确认要修改运单信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          updateInfoByCode({
            orderCode: this.waybillInfo.orderCode,
            loadQuantity: this.waybillInfo.loadQuantity, //货物装车数量
            unloadWeight: this.waybillInfo.unloadWeight, //卸车吨位
            settlementWeight: this.minWeight //结算吨位
          }).then(res => {
            if (res.status === 0) {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消修改");
        });
    },

    // 注销手机号
    cancelPhone(phone) {
      this.$confirm(`确认要注销${phone}手机号吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteUser({ phone }).then(res => {
            if (res.status === 0) {
              this.$message.success("注销成功");
              this.phoneInfo = { name: "", phone: "" };
              this.phoneForm.phoneNumber = "";
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消注销");
        });
    },

    // 查询银行信息
    queryBankInfo() {
      if (!this.bankForm.phone) {
        this.$message.warning("请输入托运人账号");
        return;
      }
      if (this.bankForm.phone.length !== 11) {
        this.$message.warning("请输入正确的托运人账号");
        return;
      }

      // 模拟查询数据
      // this.bankInfo = {
      //   companyName: "青岛***有限公司",
      //   bankName: "中国工商银行",
      //   branchName: "中国工商银行股份有限公司安宁昆钢支行"
      // };

      getBankInfo({ phone: this.bankForm.phone }).then(res => {
        if (res.status === 0) {
          this.bankInfo = res.data;
        }
      });
    },

    // 修改银行信息
    updateBankInfo() {
      if (!this.bankForm.phone) {
        this.$message.warning("请输入托运人账号");
        return;
      }
      this.$confirm("确认要修改银行信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          updateBankInfo({
            phone: this.bankForm.phone,
            bankName: this.bankInfo.bankName, //开户行
            branche: this.bankInfo.branche //银行名称
          }).then(res => {
            if (res.status === 0) {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消修改");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.zhuxiao_box {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  .zhuxiao_item {
    flex: 1;
    padding: 15px;
    border-radius: 6px;
    margin-top: 15px;
    border: 1px solid #e9ecef;
  }
}
.form_row_bg {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  margin-top: 15px;
  display: flex;
}
.platform-operations {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.platform-tabs {
  background: white;
  border-radius: 8px;
  padding: 0 20px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  ::v-deep .el-tabs__header {
    margin-bottom: 20px;
  }

  ::v-deep .el-tabs__content {
    overflow: visible;
  }

  ::v-deep .el-tab-pane {
    padding: 0;
  }
}

.operation-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
}

.card-header {
  background: #f8f9fa;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;

  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 5px 0;
  }

  .card-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
}

.card-content {
  padding: 20px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  &.center {
    justify-content: center;
  }

  &.mt-20 {
    margin-top: 20px;
  }
}

.form-label {
  min-width: 80px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  text-align: right;
}

.form-input {
  width: 300px;
  margin-right: 15px;
}

.form-select {
  width: 300px;
  margin-right: 15px;
}

.quantity-input {
  width: 100px;
}

.bank-input {
  flex: 1;
}

.unit {
  margin-left: 5px;
  margin-right: 20px;
  color: #666;
}

.query-btn,
.modify-btn {
  background: #409eff;
  border-color: #409eff;

  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
  }
}

.cancel-btn {
  background: #f56c6c;
  border-color: #f56c6c;

  &:hover {
    background: #f78989;
    border-color: #f78989;
  }
}

.form-group {
  display: flex;
  align-items: center;
  margin-right: 20px;

  &.full-width {
    width: 100%;
    margin-right: 0;
  }
}

.waybill-info,
.phone-info,
.bank-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  margin-top: 15px;
}

.subdivision-info {
  .form-label {
    min-width: 140px;
    flex-shrink: 0;
  }
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.info-label {
  font-weight: 500;
  color: #333;
}

.info-value {
  color: #666;
  margin-right: 20px;
}

.ml-30 {
  margin-left: 30px;
}

.tips {
  margin-top: 20px;
  padding: 15px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;

  p {
    margin: 5px 0;
    font-size: 14px;
    color: #856404;
  }
}
.m_r_30 {
  margin-right: 30px;
}
.phone-white-list {
  padding-top: 0;
}
.phone-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.phone-text {
  color: #333;
}
.delete-icon {
  font-size: 18px;
  color: #f56c6c;
  cursor: pointer;
  &:hover {
    color: #f78989;
  }
}
.img-section {
  margin-top: 10px;
}
.img-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.img-item {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.old-img .preview {
  width: 150px;
  height: 150px;
  object-fit: contain;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}
.upload-area {
  display: flex;
  align-items: center;
}

// 响应式设计
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    align-items: flex-start;

    .form-label {
      margin-bottom: 5px;
    }

    .form-input {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }

    .query-btn,
    .modify-btn {
      width: 100%;
    }
  }

  .form-group {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;

    .quantity-input {
      width: 80px;
    }

    .form-select,
    .form-input {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;

    .info-value,
    .info-label {
      margin-bottom: 5px;
    }
  }
}
</style>
